import React from 'react';
import { PublicAgreement } from "@kursk/components/pages/PublicAgreement/PublicAgreement";

export default function PublicAgreementPage() {
  return (<PublicAgreement />)
}
